<template>
<div class="chapter">
<div class="inner_page">
<div id="Prologue.html" xml:lang="en-US">
<div class="Basic-Text-Frame-22">
<p class="ch"><a id="Anchor-1">Prologue</a></p><a id="Anchor-1">
<p class="body-text-opening"><span class="lic">T</span>he alarm blared with such intensity the windows rattled. But the door held tight, the lock refusing to budge. Just messing with it had triggered the ultra-sensitive alarm. The sirens screeched so loudly that the noise blasted Lars Ecklund’s head, threatening to split his skull. He squinted against the strobe lights flashing in the night and grasped the stubborn doorknob, struggling to turn it.</p>
<p class="body-text">He was too close to give up without getting inside the three-story brick, glass and wrought iron mansion. But was it a house or a prison? Was his sister in there? He needed to know, needed to get to her. Now. She had been missing too long already.</p>
<p class="body-text">Strong hands grabbed his arms, dragging him back. He turned toward the other man. The muscular guy was intimidating as hell with an intense dark-eyed stare. Lars couldn’t hear what he was saying, but he didn’t need to. He knew.</p>
<p class="body-text"><em class="italic">We need to get the hell out of here...</em></p>
<p class="body-text">Frustration gripped him. He wanted to refuse, wanted to stay even if the police showed up. But his friend wouldn’t leave him. A Marine never left a man behind. And he couldn’t risk Dane getting in trouble, too.</p>
<p class="body-text">Or worse...</p>
<p class="body-text">Gunfire flashed. With the alarm blaring, he couldn’t hear the shots, but he saw them like bursts of light in the darkness. These weren’t police officers; they wouldn’t have arrived yet.</p>
<p class="body-text">These were security guards. Hell, they weren’t even that or they wouldn’t have fired before investigating. They were hired guns. Lars reached for his weapon to return fire.</p>
<p class="body-text">But Dane dragged him off—to where the truck waited in the driveway. His friend shoved him inside the open passenger’s door before slamming it shut on him and rushing around to the driver’s side. As Dane shifted the truck into Reverse, Lars peered through the windshield at the dark house.</p>
<p class="body-text">Was Emilia locked in there? Was that why he hadn’t heard from her in months?</p>
<p class="body-text">“We need to get inside!” he yelled at his friend.</p>
<p class="body-text">His arm across the back of the seat as he reversed the truck, Dane shook his head. “We’ll be lucky if we get out of here.”</p>
<p class="body-text">And as he said that, the gates in the tall brick wall surrounding the estate began to close. The dark-clothed gunmen advanced on the truck, shots pinging off the metal and hitting the glass.</p>
<p class="body-text">No. They might not get out—alive.</p>
<p class="Basic-Paragraph-19">
</p></a></div><a id="Anchor-1">
</a></div><a id="Anchor-1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Prologue.vue?b7d6b192